module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-4c36ce04d3659f7f4ad2c9b2210cf2fd.webp";